import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import StyledText from '#components/a/StyledText'
import NavStatusUebersicht from '#components/svg/icons/NavStatusUebersicht'
import {routeKeys} from '#config/routeKeys'

export default class AufgabeErstellenBenachrichtigung extends React.Component {
  onClickNotification = () => {
    const {onNotificationClick} = this.props
    onNotificationClick(routeKeys.praxisaufgabenOverview)
  }

  render() {
    const text = i18n.t('notification_text_aufgabe_erstellen', [this.props.abteilungName])
    return (
      <div
        role="button"
        tabIndex={0}
        className="notification"
        onClick={this.onClickNotification}
        onKeyPress={this.onClickNotification}
      >
        <div className="notification__icon">
          <NavStatusUebersicht />
        </div>
        <StyledText text={text} modifier="notification" />
      </div>
    )
  }
}

AufgabeErstellenBenachrichtigung.propTypes = {
  abteilungName: PropTypes.string,
  onNotificationClick: PropTypes.func,
}
